import { Link } from "react-router-dom";
import { ChevronRight } from "react-bootstrap-icons";

/**
 * Visible breadcrumb trail. Pairs with buildBreadcrumbSchema (see
 * lib/seo/structuredData.js) so a page's BreadcrumbList JSON-LD always
 * reflects real, visible structure rather than being invisible markup.
 * @param {{items: Array<{name: string, url: string}>}} props - absolute
 *   URLs (as produced by the seo metaGenerators); the current page is the
 *   last, non-linked item.
 */
export function Breadcrumb({ items }) {
  if (!items || items.length < 2) return null;

  return (
    <nav aria-label="Breadcrumb" style={{ marginBottom: 12 }}>
      <ol
        style={{
          listStyle: "none",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 4,
          margin: 0,
          padding: 0,
          fontSize: "0.75rem",
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const path = item.url.replace(/^https?:\/\/[^/]+/, "") || "/";
          return (
            <li key={item.url} style={{ display: "flex", alignItems: "center", gap: 4 }}>
              {isLast ? (
                <span style={{ color: "rgba(60,60,67,0.55)", fontWeight: 500 }}>
                  {item.name}
                </span>
              ) : (
                <Link
                  to={path}
                  style={{ color: "#007aff", textDecoration: "none", fontWeight: 500 }}
                >
                  {item.name}
                </Link>
              )}
              {!isLast && <ChevronRight size={9} color="rgba(60,60,67,0.35)" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
